import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Zotter Chocolates — Returning-customers (reorder) campaign (adc_m2qx6fs2rt).
// The only stopped reorder campaign among the real-brand variants: it ran five
// months, Feb–Jun 2025, and returned 10.1x on $347. Real spend, conversions, and
// reorder ad sales from ANALYTICS.ADS.CAMPAIGN_PERIODS; monthly series lives in
// realBrandData.ts.
export const campZcReorder: FaireAdCampaignEntity = {
  token: "camp_zc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_zotter_chocolates",
  segment: "REORDER_MARKETPLACE",
  status: "STOPPED",
  monthlyBudgetDollars: 300,
  startedRunningAt: "2025-02-19",
  stoppedRunningAt: "2025-06-25",
  segmentMetrics: {
    numReorderConversions: 13,
    salesDollars: 3495,
    totalAdsSpendDollars: 347,
    returnOnAdSpend: 10.07,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-30T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
